import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const QuotesSection = () => {
  const quotes = [{
    text: 'Your future is whatever you make it.',
    color: 'bg-bttf-secondary/10 border-bttf-secondary/30',
    glow: 'shadow-neon-blue'
  }, {
    text: "Roads? Where we're going, we don't need roads.",
    color: 'bg-bttf-primary/10 border-bttf-primary/30',
    glow: 'shadow-neon-orange'
  }, {
    text: 'If you put your mind to it, you can accomplish anything.',
    color: 'bg-bttf-highlight/10 border-bttf-highlight/30',
    glow: 'shadow-neon-purple'
  }];
  return <section className="py-6 md:py-8 bg-bttf-bg border-t border-b border-bttf-subtext/20" data-id="element-373">
      <div className="container mx-auto px-4" data-id="element-374">
        <div className="text-center mb-6" data-id="element-375">
          <div className="flex justify-center mb-2" data-id="element-376">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-377" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-378">
            Quotes That Defined a Generation
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-379"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-380">
          {quotes.map((quote, index) => <div key={index} className={`${quote.color} ${quote.glow} p-8 rounded-lg border backdrop-blur-sm flex flex-col items-center transition-transform hover:scale-105 duration-300`} data-id="element-381">
              <QuoteIcon className="h-8 w-8 text-bttf-accent mb-4" data-id="element-382" />
              <p className="text-xl font-bold text-center text-bttf-text" data-id="element-383">{`"${quote.text}"`}</p>
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto mt-6 text-center" data-id="element-384">
          <p className="text-lg text-bttf-subtext" data-id="element-385">
            These weren't just movie lines. They became mantras for dreamers,
            scientists, and storytellers around the world. Each quote in this
            book is paired with its origin, meaning, and legacy across
            generations.
          </p>
        </div>
      </div>
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-386">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-387"></polygon>
  </svg>;